import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import { CustomReportViewStateClass } from "./interfaces/CustomReportViewStateClass";
import fetchAPI from "../../../common/fetchAPI";
import { create } from "domain";
import moment from "moment";
import fetchTimeliveAPI from "../../../common/fetchTimeliveAPI";


const initialState: CustomReportViewStateClass = {
    isLoading: false,
    status: "idle",
    isReload: false,
    selectedRecord: {},
    filterList: [],
    filterDropDownList: [],
    org_FilterDropDownList:[],
    org_ReportDataList:[],
    ReportName: "",
    reportData: [],
    groupByColumn: "",
    scheduleUpdatedFlag: false
}

interface IThunkApi {
    state: {
        customReportView: CustomReportViewStateClass
    }
}

export const getFiltersByReportAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "FiltersByReport/v2/getFiltersByReport",
        async (arg, thunkApi) => {
            //Exp
            //const response = await fetchAPI("api/v2/Reports/FiltersByReport/64DDAF07-BC41-4368-8B2B-09A98E81DF4D", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            //Dep
            const response = await fetchAPI("api/v2/Reports/FiltersByReport/" + arg, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            //Emp
            // const response = await fetchAPI("api/v2/Reports/FiltersByReport/0ea60546-726c-4713-959a-a92f5929af19", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            //Exp by client
            //const response = await fetchAPI("api/v2/Reports/FiltersByReport/43af8d41-015b-4560-a66f-7e2b0fde1f7b", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            //Invoice Summary
            //const response = await fetchAPI("api/v2/Reports/FiltersByReport/4213572e-a971-406d-a24d-ba95d883a20c", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }

    )
export const generateReportAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'FiltersByReport/V2/generateReport',
        async (arg, thunkApi) => {
            const { filterDropDownList, AccountReportId } = arg;
            const response = await fetchAPI('api/V2/Reports/GenerateReport/' + AccountReportId, 'POST', filterDropDownList, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            //Exp
            //const response = await fetchAPI('api/V2/Reports/GenerateReport/64DDAF07-BC41-4368-8B2B-09A98E81DF4D', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            //Dep 
            //const response = await fetchAPI('api/V2/Reports/GenerateReport/ca89b85b-177d-4ba6-9837-d0cfcd2de6c1', 'POST', filterDropDownList, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            //Emp
            //const response = await fetchAPI('api/V2/Reports/GenerateReport/0ea60546-726c-4713-959a-a92f5929af19', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            //Exp by client
            //const response = await fetchAPI("api/v2/Reports/GenerateReport/43af8d41-015b-4560-a66f-7e2b0fde1f7b", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            //Invoice Summary
            //const response = await fetchAPI("api/v2/Reports/GenerateReport/4213572e-a971-406d-a24d-ba95d883a20c", "POST", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();
            return json;
        }
    )

export const UpdateAccountEmployeeReportSchedulePauseStatus = createAsyncThunk
    <any, any, IThunkApi>
    (
        "AccountEmployeeReportSchedule/UpdateAccountEmployeeReportSchedulePauseStatus",
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/UpdateAccountEmployeeReportSchedulePauseStatus/${arg?.AccountEmployeeReportScheduleId}`, "PUT", arg, true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = response.json();
            return json;
        }
    )

export const GetAccountEmployeeReportScheduleEmailLog = createAsyncThunk
    <any, any, IThunkApi>
    (
        'AccountEmployeeReportSchedule/GetAccountEmployeeReportScheduleEmailLog',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/GetAccountEmployeeReportScheduleEmailLog/${arg}`, 'GET', '', true);
            const json = await response.json();
            return json;
        }
    );

export const SendReportPreview = createAsyncThunk
    <any, any, IThunkApi>
    (
        'AccountEmployeeReportSchedule/SendReportPreview',
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/SendReportPreview/${arg?.email}`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    );

    export const UpdateAccountEmployeeReportScheduleStatus = createAsyncThunk
    <any, any, IThunkApi>
    (
        "AccountEmployeeReportSchedule/UpdateAccountEmployeeReportScheduleStatus",
        async (arg, thunkApi) => {
            const response = await fetchTimeliveAPI(`api/AccountEmployeeReportSchedule/UpdateAccountEmployeeReportScheduleStatus/${arg?.AccountEmployeeReportScheduleId}`, "PUT", arg, true);
            const json = response.json();
            return json;
        }
    )

const customReportViewSlice = createSlice({
    name: "customReportView",
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.filterDropDownList = state.org_FilterDropDownList;
            state.selectedRecord = {}
        },
        selectedState: (state, action) => {
            // Clone the state to avoid mutating it directly
            const newState = { ...state.filterDropDownList };

            // Destructure the payload from the action
            const { property, values } = action.payload;

            // Loop through properties array and filterDropDownList
            Object.keys(newState).forEach((propertyKey: any) => {
                if (propertyKey === property) {
                    newState[propertyKey].forEach((item: any) => {
                        // Reset isSelected for all items
                        item.isSelected = 0;
                    });

                    // Mark selected items with isSelected = 1
                    values.forEach((selectedValue: any) => {
                        const selectedItem = newState[propertyKey].find(
                            (item: any) => item.value === selectedValue
                        );
                        if (selectedItem) {
                            selectedItem.isSelected = 1;
                        }
                    });
                }
            });


            state.filterDropDownList = newState;
            // Return the updated state
            // return newState; // You might want to return a new state object if necessary
        },
        selectedSingleSelectState: (state, action) => {
            // Clone the state to avoid mutating it directly
            const newState = { ...state.filterDropDownList };

            // Destructure the payload from the action
            const { property, value } = action.payload;


            // Loop through properties array and filterDropDownList

            Object.keys(newState).forEach((property1: any, index: any) => {
                if (property1 === property) {
                    newState[property].forEach((item: any) => {
                        if (item.value === value) {
                            item.isSelected = 1;
                        }
                        else {
                            item.isSelected = 0;
                        }
                    });
                }
            });

            state.filterDropDownList = newState;
            // Return the updated state
            // return newState;
        },
        setDateRangeState: (state, action) => {
            // Clone the state to avoid mutating it directly
            const newState = { ...state.filterDropDownList };

            // Destructure the payload from the action
            const { property, dateRange } = action.payload;

            const customProperty: any = "DateRange";
            // Loop through properties array and filterDropDownList
            Object.keys(newState).forEach((property1: any, index: any) => {
                if (property1 === "DateRange") {
                    // newState[property][0].StartDate = dateRange[0];
                    // newState[property][0].EndDate = dateRange[1];
                    newState[property][0].StartDate = moment(dateRange[0]).format("YYYY-MM-DD");
                    newState[property][0].EndDate = moment(dateRange[1]).format("YYYY-MM-DD");
                }
                else if (property1 === "SubmittedDate") {
                    // newState[property][0].SubmittedStartDate = dateRange[0];
                    // newState[property][0].SubmittedEndDate = dateRange[1];
                    // newState[customProperty][0].StartDate = dateRange[0];
                    // newState[customProperty][0].EndDate = dateRange[1];
                    newState[property][0].SubmittedStartDate = moment(dateRange[0]).format("YYYY-MM-DD");
                    newState[property][0].SubmittedEndDate = moment(dateRange[1]).format("YYYY-MM-DD");
                    newState[customProperty][0].StartDate = moment(dateRange[0]).format("YYYY-MM-DD");
                    newState[customProperty][0].EndDate = moment(dateRange[1]).format("YYYY-MM-DD");
                }
            });

            state.filterDropDownList = newState;
            // Return the updated state
            // return newState;
        },
        updateProjectTaskState: (state, action) => {
            // Clone the state to avoid mutating it directly
            const newState = { ...state.filterDropDownList };

            // Destructure the payload from the action
            //const { property, values } = action.payload;

            // Loop through properties array and filterDropDownList
            Object.keys(newState).forEach((propertyKey: any) => {
                if (propertyKey === 'ProjectTask') {
                    if (action.payload.length !== 0) {
                        newState[propertyKey] = action.payload;
                    }
                    else {
                        newState[propertyKey] = [];
                    }
                }
            });


            state.filterDropDownList = newState;
        },
        updateAssignedProjectState: (state, action) => {
            // Clone the state to avoid mutating it directly
            const newState = { ...state.filterDropDownList };

            // Destructure the payload from the action
            //const { property, values } = action.payload;

            // Loop through properties array and filterDropDownList
            Object.keys(newState).forEach((propertyKey: any) => {
                if (propertyKey === 'AssignedProject') {
                    if (action.payload.length !== 0) {
                        newState[propertyKey] = action.payload;
                    }
                    else {
                        newState[propertyKey] = [];
                    }
                }
            });



            state.filterDropDownList = newState;
        },
        updateOrigReportDataState: (state, action) => {
            state.org_ReportDataList = action.payload;
        },
         updateScheduleReportFlag: (state, action) => {
            state.scheduleUpdatedFlag = action.payload;
        },
        selectedScheduleReportState: (state, action) => {
            const { property, values } = action.payload;
            const newState = { ...state.filterDropDownList };

            Object.keys(newState).forEach((propertyKey: any) => {
                if (propertyKey === property) {
                    newState[propertyKey] = newState[propertyKey].map((item: any) => ({
                        ...item,
                        isSelected: values.some((v: any) => String(v) === String(item.value)) ? 1 : 0,
                    }));
                }
            });

            state.filterDropDownList = newState;
        },
        updateAssignedProjectScheduleReportState: (state, action) => {
            const newState = { ...state.filterDropDownList };

            Object.keys(newState).forEach((propertyKey: any) => {
                if (propertyKey === 'AssignedProject') {
                    if (action.payload.length !== 0) {
                        newState[propertyKey] = action.payload.map((item: any) => ({ ...item }));
                    } else {
                        newState[propertyKey] = [];
                    }
                }
            });

            state.filterDropDownList = newState;
        },
        //     selectedState: (state, action) => {
        //         // Clone the state to avoid mutating it directly
        //         const newState = { ...state.filterDropDownList };

        //         // Destructure the payload from the action
        //         const { property, value } = action.payload;

        //         console.log('property,value:',property,value);
        //         // Loop through properties array and filterDropDownList

        //         Object.keys(newState).forEach((property1 : any, index : any) => {
        //             if (property1 === property) {
        //                 newState[property].forEach((item : any) => {
        //                     if (item.value === value) {
        //                         item.isSelected = 1;
        //                     }
        //                 });
        //             }
        //         });
        //         console.log('newState:',newState);
        //         state.filterDropDownList = newState;
        //         // Return the updated state
        //        // return newState;
        //     },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFiltersByReportAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getFiltersByReportAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";

                if (Object.keys(JSON.parse(payload.Data.FilterDropDownData)).length === 0) {
                    state.filterDropDownList = [];
                    state.org_FilterDropDownList = [];
                } else {
                    let responseArray = JSON.parse(payload.Data.FilterDropDownData);
                    if (Array.isArray(responseArray.DateRange) && responseArray.DateRange.length > 0) {
                        responseArray.DateRange[0].StartDate = new Date()
                        responseArray.DateRange[0].EndDate = new Date()
                    }
                    // state.filterDropDownList = JSON.parse(payload.Data.FilterDropDownData);
                    state.filterDropDownList = responseArray;
                    state.org_FilterDropDownList = state.filterDropDownList;
                }
                if (Object.keys(JSON.parse(payload.Data.FilterData)).length === 0) {
                    state.filterList = [];
                }
                else {
                    state.filterList = JSON.parse(payload.Data.FilterData);
                    state.ReportName = state.filterList[0].ReportName;
                }
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};
            })
            .addCase(getFiltersByReportAsync.rejected, (state) => {
                state.status = 'failed';
            })
            /////////////
            .addCase(generateReportAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(generateReportAsync.fulfilled, (state, { payload }) => {
                state.status = "idle";
                // console.log('helll',JSON.parse(payload.Data.distinctGroupValues));
                // state.reportData = JSON.parse(payload.Data.reportData);
                // state.groupByColumn = "Role";
                state.isReload = true;
                state.isLoading = false;
                state.selectedRecord = {};


            })
            .addCase(generateReportAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(UpdateAccountEmployeeReportSchedulePauseStatus.pending,(state)=>{
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(UpdateAccountEmployeeReportSchedulePauseStatus.fulfilled,(state)=>{
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(UpdateAccountEmployeeReportSchedulePauseStatus.rejected,(state)=>{
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(GetAccountEmployeeReportScheduleEmailLog.pending,(state)=>{
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(GetAccountEmployeeReportScheduleEmailLog.fulfilled,(state)=>{
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(GetAccountEmployeeReportScheduleEmailLog.rejected,(state)=>{
                state.status = 'failed';
                state.isLoading = false;
            })


    }
})

export const { resetSelectedRecordObjectInState, selectedState, selectedSingleSelectState, setDateRangeState, updateProjectTaskState, updateAssignedProjectState, updateOrigReportDataState, updateScheduleReportFlag, selectedScheduleReportState, updateAssignedProjectScheduleReportState } = customReportViewSlice.actions
export const CustomReportViewState = (state: RootState) => state.customReportView
export default customReportViewSlice.reducer